<template>
    <div>
        <div v-if="inIframe()" style="position: fixed; top: 0; z-index: 999999999; width: 100%; height: 100vh;"></div>
        <app-header></app-header>
        <slot />
        <app-footer></app-footer>
        <div class="modal fade" id="latestNotificationModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg" v-if="latestNotification.notification && latestNotification.campaign">
                <div class="modal-content">
                    <div class="modal-header" style="z-index:9999;">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body">
                        <h2 class="text-red text-center mb-2">Dagens Superdeal!</h2>
                        <campaign-item
                            class="mt-2"
                            :campaign="latestNotification.campaign"
                            :is-notification="true"
                            :title="latestNotification.notification.title"
                            :message="latestNotification.notification.message">
                            <div class="campaign-item-action mt-3">
                                <button class="btn btn-outline-dark" @click="goToLatestNotification"> {{ $t('to_the_deal') }} </button>
                                <!-- <a class="text-black ml-2" @click="closeLatestNotification">Stäng</a> -->
                            </div>
                        </campaign-item>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as Cookie from 'tiny-cookie';
    import { router } from '@inertiajs/vue3';
    import AppHeader from '@/Layouts/AppHeader';
    import AppFooter from '@/Layouts/AppFooter';
    import { doPostMessage } from '@/services/expo-app/doPostMessage';

    export default {
        data () {
            return {
                navigated: 0,
                latestNotification: { notification: null, campaign: null, },
            }
        },

        components: {
            AppHeader, AppFooter
        },

        mounted () {
            router.on('success', (event) => {
                this.navigated = this.navigated + 1;

                if (getPlatform() !== null) {
                    doPostMessage({action: 'navigated'})
                }
            });

            this.attemptToShowLatestNotification();

            $('#latestNotificationModal').on('hidden.bs.modal', () => {
                this.closeLatestNotification();
            });
        },
        created() {
            if (getPlatform() !== null) {
                const subscribeToNotification = (/** Object */ data) => {
                    axios.post('/api/site/subscribe', data).then(response => {
                        doPostMessage({action: 'subscribe'})
                    }).catch(e => {
                        doPostMessage({action: 'subscribe', error: e});
                    });
                };

                const handlePostMessage = (event) => {
                    console.log('handlePostMessage', event);

                    if (!event || !event.data || event.data.length === 0) {
                        return;
                    }

                    let message;
                    try {
                        message = (event.data instanceof Object) ? event.data : JSON.parse(event.data);
                    } catch (error) {
                        console.error(error);
                        return;
                    }

                    if (message.target !== 'web') {
                        return;
                    }

                    if (!message.action) {
                        return;
                    }

                    if (message.action === 'ping') {
                        doPostMessage({action: 'ping'});
                    } else if(message.action === 'subscribe') {
                        subscribeToNotification(message.data);
                    } else if (message.action === 'notification') {
                        this.attemptToShowLatestNotification();
                    } else if (message.action === 'navigate' && message.url) {
                        const origin = ['development', 'dev'].includes(process.env.NODE_ENV) ? 'exp://192.168.1.90:19000' : window.location.origin;

                        axios.post('/api/site/navigate', { origin: origin, url: message.url, path: message.url.replace(origin, '') }).then(response => {
                            //
                        }).catch(e => {
                            //
                        });

                        if (message.url.startsWith(origin)) {
                            const path = message.url.replace(origin, '');
                            router.visit(path);
                            doPostMessage({action: 'navigate', path: path});
                        }
                    }
                }

                // need to attach listener either to window or document depending on platform
                window.addEventListener('message', handlePostMessage);
                document.addEventListener('message', handlePostMessage);
            }
        },
        methods: {
            latestNotificationModal () {
                return bootstrap.Modal.getOrCreateInstance(document.querySelector('#latestNotificationModal'))
            },
            inIframe () {
                try {
                    return window.self !== window.top;
                } catch (e) {
                    return true;
                }
            },
            async attemptToShowLatestNotification () {
                if (!getPlatform()) {
                    return;
                }

                await axios.get(`/api/site/latest-notification?platform=${getPlatform()}`).then(response => {
                    if (response.data.campaign !== undefined) {
                        this.latestNotification = response.data;
                    }
                });

                if (this.latestNotification && this.latestNotification.notification) {
                    if (!(Cookie.get('familjekortet_lastest_notification') == this.latestNotification.notification.id)) {
                        this.latestNotificationModal().show();
                    }
                }
            },
            goToLatestNotification () {
                var campaign = this.latestNotification.campaign;
                Cookie.set('familjekortet_lastest_notification', this.latestNotification.notification.id, { expires: '1Y' });
                this.latestNotificationModal().hide();
                router.visit(`/${campaign.company_slug}/${campaign.slug}`);
            },
            closeLatestNotification () {
                Cookie.set('familjekortet_lastest_notification', this.latestNotification.notification.id, { expires: '1Y' });
                this.latestNotificationModal().hide();
            }
        },
    }
</script>
